var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4714 4.47206C12.7318 4.21171 12.7318 3.7896 12.4714 3.52925C12.2111 3.2689 11.789 3.2689 11.5286 3.52925L8.00001 7.05784L4.47141 3.52925C4.21107 3.2689 3.78896 3.2689 3.52861 3.52925C3.26826 3.7896 3.26826 4.21171 3.52861 4.47206L7.0572 8.00065L3.52861 11.5292C3.26826 11.7896 3.26826 12.2117 3.52861 12.4721C3.78896 12.7324 4.21107 12.7324 4.47141 12.4721L8.00001 8.94346L11.5286 12.4721C11.789 12.7324 12.2111 12.7324 12.4714 12.4721C12.7318 12.2117 12.7318 11.7896 12.4714 11.5292L8.94282 8.00065L12.4714 4.47206Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f22da686ac78d27bd8709086c4bb7a04.svg";
export { ForwardRef as ReactComponent };